import usePageData from '@composables/usePageData';
import { IKillSwitch } from '@types/definitions'; // eslint-disable-line no-unused-vars
/**
 * Composable for getting the killswitch properties
 * @returns {IKillSwitch} - Returns a KillSwitch object
 */
export default function useKillSwitches() {
  const pageData = usePageData();
  const properties = pageData?.value?.meta?.properties || {};
  const {
    brand = '',
    isBigTicketCXSearchAndBrowseTypeEnabled = false,
    isSiteMonHeartFunctionalityEnabled = false,
    contextualWidgetEnabled = false,
    isSalesFloorSearchEnabled = false,
    uniqueSearchPatternEnabled = false,
    pzoBadgingEnabled = false,
    scrollyCatsEnabled = false,
    priceSimplificationEnabled = false,
    newBreadcrumbStructureEnabled = false,
    loyaltyBadgeEnhancementEnabled = false,
    enableH3ProductTitlesSortableGrid = false,
    discoveryGridQuickShopEnabled = false,
    macysExclusiveEnabled = false,
    newGoogleAPICallEnabled = false,
    newPlacesDetailsApiEnabled = false,
    storeInPreferenceDatabaseEnabled = false,
    secondRowBadgeEnabled = false,
    valueGiftBadgeEnabled = false,
    disableSplashLeftHandNavigation = false,
  } = properties;

  return {
    brand,
    isBigTicketCXSearchAndBrowseTypeEnabled,
    isSiteMonHeartFunctionalityEnabled,
    contextualWidgetEnabled,
    isSalesFloorSearchEnabled,
    uniqueSearchPatternEnabled,
    pzoBadgingEnabled,
    scrollyCatsEnabled,
    priceSimplificationEnabled,
    newBreadcrumbStructureEnabled,
    loyaltyBadgeEnhancementEnabled,
    enableH3ProductTitlesSortableGrid,
    discoveryGridQuickShopEnabled,
    macysExclusiveEnabled,
    newGoogleAPICallEnabled,
    newPlacesDetailsApiEnabled,
    storeInPreferenceDatabaseEnabled,
    secondRowBadgeEnabled,
    valueGiftBadgeEnabled,
    disableSplashLeftHandNavigation,
  };
}
